/* tslint:disable */
/* eslint-disable */
/**
 * Melco Efs APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    EfsMelcoEfsModelsMappingFileAttribute,
    EfsMelcoEfsModelsMappingFileAttributeFromJSON,
    EfsMelcoEfsModelsMappingFileAttributeFromJSONTyped,
    EfsMelcoEfsModelsMappingFileAttributeToJSON,
    EfsMelcoEfsModelsSchemaListItem,
    EfsMelcoEfsModelsSchemaListItemFromJSON,
    EfsMelcoEfsModelsSchemaListItemFromJSONTyped,
    EfsMelcoEfsModelsSchemaListItemToJSON,
} from './';

/**
 * 
 * @export
 * @interface EfsMelcoEfsModelsFormat
 */
export interface EfsMelcoEfsModelsFormat {
    /**
     * 
     * @type {string}
     * @memberof EfsMelcoEfsModelsFormat
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EfsMelcoEfsModelsFormat
     */
    key?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EfsMelcoEfsModelsFormat
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EfsMelcoEfsModelsFormat
     */
    desc?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EfsMelcoEfsModelsFormat
     */
    display_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EfsMelcoEfsModelsFormat
     */
    xml_orders_xpath?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EfsMelcoEfsModelsFormat
     */
    unique_field?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof EfsMelcoEfsModelsFormat
     */
    headers?: boolean;
    /**
     * 
     * @type {number}
     * @memberof EfsMelcoEfsModelsFormat
     */
    config_count?: number;
    /**
     * 
     * @type {Array<EfsMelcoEfsModelsSchemaListItem>}
     * @memberof EfsMelcoEfsModelsFormat
     */
    schema_list?: Array<EfsMelcoEfsModelsSchemaListItem> | null;
    /**
     * 
     * @type {string}
     * @memberof EfsMelcoEfsModelsFormat
     */
    type?: string | null;
    /**
     * 
     * @type {Array<EfsMelcoEfsModelsMappingFileAttribute>}
     * @memberof EfsMelcoEfsModelsFormat
     */
    filename_rules_list?: Array<EfsMelcoEfsModelsMappingFileAttribute> | null;
}

export function EfsMelcoEfsModelsFormatFromJSON(json: any): EfsMelcoEfsModelsFormat {
    return EfsMelcoEfsModelsFormatFromJSONTyped(json, false);
}

export function EfsMelcoEfsModelsFormatFromJSONTyped(json: any, ignoreDiscriminator: boolean): EfsMelcoEfsModelsFormat {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'key': !exists(json, 'key') ? undefined : json['key'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'desc': !exists(json, 'desc') ? undefined : json['desc'],
        'display_name': !exists(json, 'display_name') ? undefined : json['display_name'],
        'xml_orders_xpath': !exists(json, 'xml_orders_xpath') ? undefined : json['xml_orders_xpath'],
        'unique_field': !exists(json, 'unique_field') ? undefined : json['unique_field'],
        'headers': !exists(json, 'headers') ? undefined : json['headers'],
        'config_count': !exists(json, 'config_count') ? undefined : json['config_count'],
        'schema_list': !exists(json, 'schema_list') ? undefined : (json['schema_list'] === null ? null : (json['schema_list'] as Array<any>).map(EfsMelcoEfsModelsSchemaListItemFromJSON)),
        'type': !exists(json, 'type') ? undefined : json['type'],
        'filename_rules_list': !exists(json, 'filename_rules_list') ? undefined : (json['filename_rules_list'] === null ? null : (json['filename_rules_list'] as Array<any>).map(EfsMelcoEfsModelsMappingFileAttributeFromJSON)),
    };
}

export function EfsMelcoEfsModelsFormatToJSON(value?: EfsMelcoEfsModelsFormat | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'key': value.key,
        'name': value.name,
        'desc': value.desc,
        'display_name': value.display_name,
        'xml_orders_xpath': value.xml_orders_xpath,
        'unique_field': value.unique_field,
        'headers': value.headers,
        'config_count': value.config_count,
        'schema_list': value.schema_list === undefined ? undefined : (value.schema_list === null ? null : (value.schema_list as Array<any>).map(EfsMelcoEfsModelsSchemaListItemToJSON)),
        'type': value.type,
        'filename_rules_list': value.filename_rules_list === undefined ? undefined : (value.filename_rules_list === null ? null : (value.filename_rules_list as Array<any>).map(EfsMelcoEfsModelsMappingFileAttributeToJSON)),
    };
}


